





























import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { MultipleSelect } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';
import { formatDate, formattedDate, parseFloatNumber } from '../../core/utils';
import Loading from 'vue-loading-overlay';
import Input from '../../core/components/Input.vue';
import { Vehicle } from '../../core/models/Vehicle';
@Component({
    components: { MultipleSelect, Loading, SimpleTable, SectionTitle, Input }
})
export default class UserList extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default(){return []}}) vehicles: Array<Vehicle>;
    headers: Array<object> = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Vin',
            align: 'center',
            value: 'vin'
        },
        {
            text: 'Matrícula',
            align: 'center',
            value: 'vehicle_plate'
        }
    ];
    items: Array<Vehicle> = [];
    search: string = '';
    pendingRequest: boolean = false;
    sortBy: string[] = ["description"];
    sortDesc: boolean[] = [false];
    sectionTitle: string = 'Listado de Vehículos';
    noDataText: string = 'No hay usuarios para mostrar';

    loadingTable(value: boolean){
        this.pendingRequest = value;
    }

    updateSearchValue(value){
        this.search = value;
    }

    created(){
     
    }

}
